import { FunctionComponent, useState } from "react";
import { ColorClassNames } from "manifest-components/src/Colors";
import Chevron, { ChevronOrientation } from "manifest-components/src/Images/icons/Chevron";
import { NewTransferStatusType } from "manifest-components/src/classes/transferInstruction";
import * as Styled from "./styles";
import { getTransferStatusHeading, getTransferStatusProgress } from "./helpers";

interface TransferStatusTileProps {
  status: NewTransferStatusType;
  description: string;
  sourceAccount: string;
  destiantionAccount: string;
  transferInstructionId: string;
}

const TransferStatusTile: FunctionComponent<TransferStatusTileProps> = ({
  status,
  description,
  sourceAccount,
  destiantionAccount,
  transferInstructionId,
}: TransferStatusTileProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  return (
    <Styled.TransferStatusTileContainer data-name={`transfer-status-tile-${transferInstructionId}`}>
      <Styled.TransferStatusTileHeader>
        {getTransferStatusProgress(status)}
        <Styled.TransferStatusTileHeaderContent>
          <div className="source">
            <span className={`label ${ColorClassNames.coco5} xsmall`}>From</span>
            <span className={`value ${ColorClassNames.coco9} small bold`}>{sourceAccount}</span>
          </div>
          <div className="destination">
            <span className={`label ${ColorClassNames.coco5} xsmall`}>To</span>
            <span className={`value ${ColorClassNames.coco9} small bold`}>
              {destiantionAccount}
              {(status === NewTransferStatusType.WAIT_FOR_IRA_OPENING ||
                status === NewTransferStatusType.IRA_OPENING_ERROR) &&
                ` (Pending)`}
            </span>
          </div>
        </Styled.TransferStatusTileHeaderContent>
      </Styled.TransferStatusTileHeader>
      <Styled.TransferStatusTileAccordion>
        <Styled.TransferStatusTileAccordionHeader onClick={() => setIsOpened(!isOpened)}>
          <span
            className={`${
              status === NewTransferStatusType.CANCELLED ||
              status === NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED ||
              status === NewTransferStatusType.SCHEDULE_PHONE_CALL ||
              status === NewTransferStatusType.IRA_OPENING_ERROR
                ? ColorClassNames.cherry
                : ColorClassNames.mint
            } xsmall`}
          >
            Status
          </span>
          <div className="transfer-status-heading">
            <span className={`xsmall ${ColorClassNames.coco9}`}> {getTransferStatusHeading(status)}</span>
          </div>

          <Styled.TransferStatusTileAccordionIcon>
            <Chevron orientation={isOpened ? ChevronOrientation.UP : ChevronOrientation.DOWN} />
          </Styled.TransferStatusTileAccordionIcon>
        </Styled.TransferStatusTileAccordionHeader>
        <Styled.TransferStatusTileAccordionContent $isOpened={isOpened}>
          {description || "Manifest is processing your transfer. No action is needed"}
        </Styled.TransferStatusTileAccordionContent>
      </Styled.TransferStatusTileAccordion>
    </Styled.TransferStatusTileContainer>
  );
};

export default TransferStatusTile;
